import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import get from 'lodash-es/get';

import { RouteEnum } from 'app/shared/enums';
import { selectTravelQuotationStatus } from 'app/store/data/travelQuotation';
import { afterCalculationStatuses } from 'app/shared/helpers/quotation';
import { initTravelQuotation } from 'app/store/data/travelQuotation';

export function useTravelCalculationBaseView() {
  const dispatch = useDispatch();
  const location = useLocation();
  const travelQuotationStatus = useSelector(selectTravelQuotationStatus);
  const recoveryKey = get(location, 'state.quotationId');

  const initQuotation = () => {
    dispatch(initTravelQuotation(recoveryKey));
  };

  const shouldRedirectToCalculationForm =
    (location.pathname === RouteEnum.TRAVEL_CALCULATION_RESULTS &&
      travelQuotationStatus &&
      !afterCalculationStatuses.includes(travelQuotationStatus)) ||
    location.pathname === RouteEnum.TRAVEL;

  const shouldRedirectToResults =
    (location.pathname === `${RouteEnum.TRAVEL}/` ||
      location.pathname === RouteEnum.TRAVEL_FORM ||
      location.pathname === RouteEnum.TRAVEL_FORM_FB) &&
    travelQuotationStatus &&
    afterCalculationStatuses.includes(travelQuotationStatus);

  useEffect(initQuotation, [dispatch, recoveryKey]);

  return {
    location,
    shouldRedirectToCalculationForm,
    shouldRedirectToResults,
    travelQuotationStatus,
  };
}
